import { defineSlotRecipe as e } from "@pandacss/dev";
import { anatomy as o } from "../../node_modules/@ark-ui/anatomy/dist/date-picker/index.mjs";
const a = e({
  className: "date-picker",
  slots: [...o.keys()],
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "1.5"
    },
    content: {
      boxShadow: "lg",
      display: "flex",
      flexDirection: "column",
      gap: "3",
      p: "4",
      width: "360px",
      background: "base.white",
      _open: {
        animation: "fadeIn 0.25s ease-out"
      },
      _closed: {
        animation: "fadeOut 0.2s ease-out"
      },
      _hidden: {
        display: "none"
      }
    },
    control: {
      display: "flex",
      flexDirection: "row",
      gap: "2"
    },
    label: {
      color: "fg.default",
      fontSize: "lg",
      textStyle: "sm"
    },
    tableHeader: {
      fontWeight: "semibold",
      height: "10",
      textStyle: "sm"
    },
    viewControl: {
      display: "flex",
      gap: "2",
      justifyContent: "space-between"
    },
    nextTrigger: {
      border: "none !important",
      backgroundColor: "transparent !important",
      color: "base.black"
    },
    prevTrigger: {
      border: "none !important",
      backgroundColor: "transparent !important",
      color: "base.black"
    },
    table: {
      width: "full",
      borderCollapse: "separate",
      borderSpacing: "1",
      m: "-1"
    },
    tableCell: {
      textAlign: "center"
    },
    tableCellTrigger: {
      width: "100%",
      backgroundColor: "transparent !important",
      color: "text-primary !important",
      border: "none",
      _today: {
        border: "1px solid",
        borderColor: "border-secondary !important"
      },
      "&[data-in-range]": {
        background: "bg.muted"
      },
      "&[data-disabled]": {
        color: "base.white !important"
      },
      "&[aria-disabled=true]": {
        color: "text-disabled !important"
      },
      _selected: {
        backgroundColor: "bg-brand-primary !important",
        borderRadius: "2",
        color: "base.white !important"
      }
    },
    view: {
      display: "flex",
      flexDirection: "column",
      gap: "3",
      _hidden: {
        display: "none"
      }
    }
  }
});
export {
  a as datePickerRecipe
};
